export default "__VITE_ASSET__200778fe__"